import { FC } from "react";
import { IClassname } from "@/lib/types/classname";

export const FilterHospital: FC<IClassname> = ({ className }) => {
  return (
    <svg
      className={className}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84615 8.84615V4H13.1538V8.84615H18V13.1538H13.1538V18H8.84615V13.1538H4V8.84615H8.84615Z"
        stroke="white"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
    </svg>
  );
};
